import TableRowPlaceholder from './table-row-placeholder';

export default TableRowPlaceholder;